export default __webpack_public_path__ + "static/media/30d747e24335b631bb158d374da8cb0e.jpg";